/**
 * Transforms dynamic pet input object into structured output.
 * @param input Record<string, any> - The flat input object.
 * @returns Structured pet object.
 */
export function getPetOutputForAgent(input: Record<string, any>, petId?: string) {
    const keys = Object.keys(input);
    if (keys.length === 0) return null;

    // Extract pet_type and pet_index from the first key
    const [pet_type, , pet_index] = keys[0].split(".");

    // Build fields object dynamically
    const fields: Record<string, any> = {};
    keys.forEach((key) => {
        const parts = key.split(".");
        if (parts.length < 3) return;
        const [, fieldName] = parts;
        fields[fieldName] = input[key];
    });

    return {
        pet_id: petId ?? "",
        pet_type,
        pet_index: Number(pet_index),
        fields,
    };
}